<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="calibrationForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                calibrationForm: () => import('../forms/CalibrationForm'),
                headers: [
                    { text: 'Equipment Item', value: 'equipmentItemId', table: 'equipmentItems', form: () => import('../forms/EquipmentItemForm') },
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Has Passed', value: 'hasPassed' },
                    { text: 'Invoice File', value: 'invoiceFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: 'Record File', value: 'recordFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: 'Weight Calibrated', value: 'weightCalibrated' },
                    { text: 'Calibrated By Company', value: 'calibratedByCompany' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    equipmentItems: [],
                    files: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "calibratedByCompany", direction: "ascending" },
                    { column: "equipmentItemId", direction: "ascending" },
                ],
                itemsField: 'calibrations',
                editPageName: 'calibration',
                apiMethod: 'Calibrations',
                claimName: 'Calibrations',
                formTitle: 'Calibration',
                excelTitle: 'Calibrations',
                hasEditPage: false,
            }
        },
    };
</script>
